module.exports = "<button class=\"btn btn-default btn-lg\"\n        spinning-wheel [is-spinning-wheel-active]=\"isSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\"\n        (click)=\"saveAsPdf()\">\n    <i class=\"fa fa-file-pdf-o\"></i>Save As PDF\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.html
// module id = ./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.html
// module chunks = 0